import styled from "@xstyled/styled-components";

import { DesktopContentProps } from "../tabs/DesktopContent";
import { ExperienceBar } from "../components/ExperienceBar";
import { JobLocationsSection } from "../components/JobLocationsSection";
import { SalarySection } from "../components/SalarySection";
import { TechnologiesUsedTags } from "../components/TechnologiesUsedTags";

import { pxToRem } from "@otta/design-tokens";

const TopCardSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(12)};
`;

export const SalaryTechExperienceLocation = ({
  job,
  user,
}: Pick<DesktopContentProps, "job" | "user">): React.ReactElement => {
  return (
    <TopCardSection>
      <SalarySection job={job} company={job.company} />
      <TechnologiesUsedTags job={job} user={user} />
      <ExperienceBar job={job} />
      <JobLocationsSection job={job} user={user} />
    </TopCardSection>
  );
};
